import { FieldDefinition, LinkDefinition, LookupFieldDefinition } from '../../definitions'
import { readEntityModelByName, readEntityModelIncludeExternal } from '../../utils/metadata-storage'
import { FieldValue, GenericFieldValue } from './field.class'

export class LookupValue extends FieldValue<string> {
  public entityName: string
  public entityDescription: string
  public fields: Record<string, GenericFieldValue>
  public isDeleted: boolean

  constructor(value?: string) {
    super()
    this.value = value
    this.entityName = ''
    this.entityDescription = ''
    this.fields = {}
    this.isDeleted = false
  }

  public mapField(field: LookupValue, fieldDef: LookupFieldDefinition, ms?: string): void {
    this.value = field.value
    this.entityName = field.entityName
    this.entityDescription = field.entityDescription
    this.isDeleted = field.isDeleted
    this.fields = {}
    if (field.fields) {
      const link = fieldDef.links.find((l) => l.linkedEntity === this.entityName) as LinkDefinition
      let entityModel = readEntityModelByName(link.linkedEntity)
      if (ms) {
        entityModel = readEntityModelIncludeExternal(link.linkedEntity, ms)
      }
      link.includedFields.forEach((f) => {
        const fValue = field.fields[f]
        const fDef = entityModel?.getFieldDefinition(f) as FieldDefinition
        const fValueInstance = fDef?.getFieldValue()
        if (fValue) fValueInstance?.mapField(field.fields[f], fDef)
        this.fields[f] = fValue ? fValueInstance : null
      })
    }
  }
  public toStringForView(): string {
    return this.entityDescription
  }
}
